import { clsx } from "clsx";
import { Platform, TextInput, type TextInputProps } from "react-native";

// Adapted from react-native-reusable input
export function Input({
  className,
  ...props
}: TextInputProps & React.RefAttributes<TextInput>) {
  return (
    <TextInput
      className={clsx(
        "dark:bg-input/30 border-input bg-background text-foreground flex min-w-0 flex-row items-center rounded-md border p-2 text-base leading-5 shadow-sm shadow-black/5",
        props.editable === false &&
          clsx(
            "opacity-50",
            Platform.select({
              web: "disabled:pointer-events-none disabled:cursor-not-allowed",
            })
          ),
        Platform.select({
          web: clsx(
            "placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground outline-none transition-[color,box-shadow] md:text-sm",
            "focus-visible:ring-ring/50 focus-visible:ring-[3px] focus-visible:ring-blue-500 focus-visible:border-transparent",
            "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
          ),
          native: "placeholder:text-muted-foreground/50",
        }),
        className
      )}
      {...props}
    />
  );
}
